import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { AdminOnly, NotPartner, PartnerOnly, PdOnly, PlatformOnly, RequireAuth, StaffOnly } from '@/router-guards'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { OrdersPage } from '@/pages/OrdersPage'
import { OrderDetailPage } from '@/pages/OrderDetailPage'
import { CompaniesPage } from '@/pages/CompaniesPage'
import { CompanyDetailPage } from '@/pages/CompanyDetailPage'
import { UsersPage } from '@/pages/UsersPage'
import { UserDetailPage } from '@/pages/UserDetailPage'
import { AuditPage } from '@/pages/AuditPage'
import { ClientErrorsPage } from '@/pages/ClientErrorsPage'
import { PdLogPage } from '@/pages/PdLogPage'
import { MapPage } from '@/pages/MapPage'
import { ReportsPlaceholder } from '@/pages/ReportsPlaceholder'
import { TariffsPage } from '@/pages/TariffsPage'
import { BillingPage } from '@/pages/BillingPage'
import { NotificationLogPage } from '@/pages/NotificationLogPage'
import { TriggersPage } from '@/pages/notifications/TriggersPage'
import { BroadcastPage } from '@/pages/notifications/BroadcastPage'

import { PushSubscriptionsPage } from '@/pages/notifications/PushSubscriptionsPage'
import { AppVersionsPage } from '@/pages/AppVersionsPage'
import { DkpGeneratorPage } from '@/pages/DkpGeneratorPage'
import { InspectorLastPositionPage } from '@/pages/InspectorLastPositionPage'
import { SystemConfigPage } from '@/pages/SystemConfigPage'
import { GeoSettingsPage } from '@/pages/GeoSettingsPage'
import { TelegramLeadsSettingsPage } from '@/pages/TelegramLeadsSettingsPage'
import { SmsSettingsPage } from '@/pages/SmsSettingsPage'
import { SberSmsSettingsPage } from '@/pages/SberSmsSettingsPage'
import { SberNotifyLogPage } from '@/pages/SberNotifyLogPage'
import { AvitoApiLogPage } from '@/pages/AvitoApiLogPage'
import { HelpPage } from '@/pages/HelpPage'
import { AvitoHelpPage } from '@/pages/AvitoHelpPage'
import { UserFeedbackPage } from '@/pages/UserFeedbackPage'
import { UserFeedbackDetailPage } from '@/pages/UserFeedbackDetailPage'
import { InspectorsPositionsPage } from '@/pages/InspectorsPositionsPage'
import { NearestInspectorsPage } from '@/pages/NearestInspectorsPage'
import { DispatchMapPage } from '@/pages/DispatchMapPage'
import { InspectionLeadsPage } from '@/pages/InspectionLeadsPage'
import { InspectionLeadDetailPage } from '@/pages/InspectionLeadDetailPage'
import { PartnerShell } from '@/components/partner/PartnerShell'
import { PartnerLeadsPage } from '@/pages/partner/PartnerLeadsPage'
import { PartnerLeadPage } from '@/pages/partner/PartnerLeadPage'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/partner',
        element: <PartnerOnly />,
        children: [
          {
            element: <PartnerShell />,
            children: [
              { index: true, element: <PartnerLeadsPage /> },
              { path: 'leads/:id', element: <PartnerLeadPage /> },
            ],
          },
        ],
      },
      {
        element: <NotPartner />,
        children: [
          {
            path: '/',
            element: <AppShell />,
            children: [
              { index: true, element: <DashboardPage /> },
              { path: 'orders', element: <OrdersPage /> },
              { path: 'orders/:id', element: <OrderDetailPage /> },
              { path: 'help', element: <HelpPage /> },
              { path: 'help/avito', element: <AvitoHelpPage /> },
              {
                element: <PlatformOnly />,
                children: [
                  { path: 'map', element: <MapPage /> },
                  { path: 'dispatch-map', element: <DispatchMapPage /> },
                  { path: 'inspectors-positions', element: <InspectorsPositionsPage /> },
                  {
                    path: 'inspectors/:id/last-position',
                    element: <InspectorLastPositionPage />,
                  },
                  {
                    path: 'orders/:id/nearest-inspectors',
                    element: <NearestInspectorsPage />,
                  },
                  { path: 'inspection-leads', element: <InspectionLeadsPage /> },
                  { path: 'inspection-leads/:id', element: <InspectionLeadDetailPage /> },
                ],
              },
              {
                element: <StaffOnly />,
                children: [
                  {
                    element: <AdminOnly />,
                    children: [
                      { path: 'companies', element: <CompaniesPage /> },
                      { path: 'companies/:id', element: <CompanyDetailPage /> },
                      { path: 'users', element: <UsersPage /> },
                      { path: 'users/:id', element: <UserDetailPage /> },
                      { path: 'audit', element: <AuditPage /> },
                      { path: 'client-errors', element: <ClientErrorsPage /> },
                      { path: 'reports', element: <ReportsPlaceholder /> },
                      { path: 'tariffs', element: <TariffsPage /> },
                      { path: 'billing', element: <BillingPage /> },
                      { path: 'notifications/log', element: <NotificationLogPage /> },
                      { path: 'notifications/triggers', element: <TriggersPage /> },
                      { path: 'notifications/broadcast', element: <BroadcastPage /> },

                      { path: 'notifications/subscriptions', element: <PushSubscriptionsPage /> },
                      { path: 'notifications/app-versions', element: <AppVersionsPage /> },
                      { path: 'dkp-generator', element: <DkpGeneratorPage /> },
                      { path: 'system-config', element: <SystemConfigPage /> },
                      { path: 'geo-settings', element: <GeoSettingsPage /> },
                      { path: 'telegram-settings', element: <TelegramLeadsSettingsPage /> },
                      { path: 'sms-settings', element: <SmsSettingsPage /> },
                      { path: 'sber-sms-settings', element: <SberSmsSettingsPage /> },
                      { path: 'avito-api-log', element: <AvitoApiLogPage /> },
                      { path: 'sber-notify-log', element: <SberNotifyLogPage /> },
                      { path: 'user-feedback', element: <UserFeedbackPage /> },
                      { path: 'user-feedback/:id', element: <UserFeedbackDetailPage /> },
                    ],
                  },
                  {
                    element: <PdOnly />,
                    children: [{ path: 'pd-log', element: <PdLogPage /> }],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
